export const LEARNING_STYLE_QUESTION = 'How do you like to learn new things?'

export const LEARNING_STYLE_OPTIONS = [
  { key: 'book', i18nKey: 'book' },
  { key: 'audiobooks', i18nKey: 'audiobooks' },
  { key: 'podcasts', i18nKey: 'podcasts' },
  { key: 'videos', i18nKey: 'videos' },
  { key: 'courses', i18nKey: 'courses' },
] as const
